import { Injectable, Injector } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Application } from '@enums/application.enums';
import { APIENDPOINT, API_URLS } from '@core/api-url.enum';
import { ApiCallService } from '@services/api-call.service';
import { CommonService } from '@shared/services/common.service';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import * as fromUserProfile from '@shared/user-profile.reducer';
import * as userProfileAction from '@shared/user-profile.action';
import { Router } from '@angular/router';
import {
  debounceTime,
  distinctUntilChanged,
  BehaviorSubject,
  takeUntil,
  Subject,
  Observable,
  EMPTY,
  of,
  timer
} from 'rxjs';
import {
  catchError,
  filter,
  map,
  startWith,
  switchMap,
  take,
  tap
} from 'rxjs/operators';
import { MENTION_SEARCH } from '@modules/dashboard/constants/mention.constant';
import {
  hasOnlyLoyaltyPointsLock,
  loyaltyOnlyLockAcknowledgementFingerprint,
  mapSubscriptionDataToLoyaltyLockShape
} from '@utils/loyalty-points.utils';
import { CollabPermission } from 'src/app/model/collabPermission';
import { AuthService } from '@core/auth.service';
import { environment } from '@environments/environment';
@Injectable({ providedIn: 'root' })
export class DashboardModuleService {
  private modalRef: BsModalRef;
  schedulePost: string;
  atTaggingUsers = new BehaviorSubject<any[]>([]);
  valueSelected$ = new BehaviorSubject<boolean>(false);
  blockedUsers: any[];
  loggedInUser;
  editPostStatus$ = new BehaviorSubject<{
    isSechdule: boolean;
    isEdit: boolean;
    isUpdateOnly?: boolean
  }>({ isSechdule: false, isEdit: false, isUpdateOnly: false });
  mentionUl: HTMLElement;
  mentionModal: HTMLElement;
  cardsMessageForm: any;
  readonly MENTION_MODAL_FLIP_THRESHOLD = 0.7;
  destroy$ = new Subject<void>();

  private lastAcknowledgedLoyaltyOnlyFingerprint: string | null = null;
  private readonly mentionUserCache = new Map<
    string,
    { items: any[]; expiresAt: number }
  >();

  constructor(
    private readonly apiCallService: ApiCallService,
    private readonly cs: CommonService,
    private readonly modalService: BsModalService,
    private readonly modal: NgbModal,
    public readonly store: Store<fromUserProfile.UserProfileState>,
    private readonly router: Router,
    _injector: Injector,
    public authService: AuthService
  ) {
    this.authService = _injector.get<AuthService>(AuthService);
    this.userFollowerList()
    .pipe(takeUntil(this.destroy$))
    .subscribe((res: any) => {
      this.blockedUsers = res.blocked;
    });
    this.loginUserProfile();
  }

  fetchHashTagList() {
    return this.apiCallService.get(API_URLS.getHashtagList, false);
  }

  getHashTagPagination(lastEvaluatedKeyHashTags) {
    if (
      lastEvaluatedKeyHashTags &&
      lastEvaluatedKeyHashTags.pk &&
      lastEvaluatedKeyHashTags.sk
    ) {
      return this.apiCallService.get(
        APIENDPOINT.adminHashTags(
          this.cs.encodeToUTF(lastEvaluatedKeyHashTags.pk),
          this.cs.encodeToUTF(lastEvaluatedKeyHashTags.sk),
          this.cs.encodeToUTF(lastEvaluatedKeyHashTags.gsi1pk),
          this.cs.encodeToUTF(lastEvaluatedKeyHashTags.gsi1sk)
        ),
        false
      );
    }
  }

  getReplyComments(commentId) {
    this.apiCallService
      .get(APIENDPOINT.replyGetComments(commentId), true)
      .subscribe({
        next: (res) => {
          if (res.status) {
            return res.data;
          } else {
            return this.cs.showErrorMessage(res.message);
          }
        },
        error: (err) => {
          return this.cs.showErrorMessage(err.message);
        }
      });
  }

  saveEditPostStatus(isSechduleStatus?, isEditStatus?) {
    this.editPostStatus$.next({
      isSechdule: isSechduleStatus,
      isEdit: isEditStatus
    });
  }

  likeUserPost(encPk, encSk, status?): Promise<boolean> {
    this.cs.setGTag('total-likes', 'like');
    status = status === true ? { is_pinned: true } : { is_pinned: false, is_ad: status?.is_ad || false };
    return new Promise((Resolve, Reject) => {
      this.apiCallService
        .put(APIENDPOINT.likePost(encPk, encSk), status, false)
        .subscribe({
          next: (res) => {
            if (res.status) {
              Resolve(res.status);
            } else {
              this.cs.showErrorMessage(res.message);
              Reject(res.status);
            }
          },
          error: (err) => {
            this.cs.showErrorMessage(err.message);
            Reject(false);
          }
        });
    });
  }

  deslikeUserPost(encPk, encSk, is_ad?: boolean): Promise<boolean> {
    this.cs.setGTag('unlike-post', 'unlike');
    let url = APIENDPOINT.deleteLike(encPk, encSk);
    if (is_ad) {
      url = `${APIENDPOINT.deleteLike(encPk, encSk)}?is_ad=true`;
    }
    return new Promise((Resolve, Reject) => {
      this.apiCallService
        .delete(url, false)
        .subscribe({
          next: (res) => {
            if (res.status) {
              Resolve(res.status);
            } else {
              this.cs.showErrorMessage(res.message);
              Reject(res.status);
            }
          },
          error: (err) => {
            this.cs.showErrorMessage(err.message);
            Reject(false);
          }
        });
    });
  }

  async tagModal(data?) {
    const { TagComponent } = await import('../components/new-post/dialog-box/tag/tag.component');
    const modalInfo = Object.assign({
      userPost: data
    });
    this.modalRef = this.modalService.show(TagComponent, {
      initialState: modalInfo,
      backdrop: 'static',
      class: 'modal-small'
    });
    this.modalRef.onHide.subscribe(() => {});
  }

  async postPriceModal(data?) {
    const { PostPriceComponent } = await import('../components/new-post/dialog-box/post-price/post-price.component');
    const modalInfo = Object.assign({
      userPost: data
    });
    this.modalRef = this.modalService.show(PostPriceComponent, {
      initialState: modalInfo,
      backdrop: 'static',
      class: 'modal-lg'
    });
    this.modalRef.onHide.subscribe(() => {});
  }

  isWhiteSpace(event, form: UntypedFormGroup) {
    if (
      !event.target.value.trim() &&
      event.charCode === Application.THIRTY_TWO
    ) {
      form.controls['description'].reset();
      form.get('description').updateValueAndValidity();
      return false;
    }
    return null;
  }

  resetForm(form: UntypedFormGroup) {
    return form.reset();
  }

  validDate() {
    return new Date();
  }

  setSchedulePost(schedulePost) {
    if (schedulePost) {
      this.schedulePost = schedulePost;
    } else {
      this.schedulePost = '';
    }
  }

  getSchedulePost() {
    if (this.schedulePost) {
      return this.schedulePost;
      // return formatDate(new Date(this.schedulePost), 'yyyy-MM-dd H:mm', 'en-US', 'GMT');
    } else {
      return null;
    }
  }

  getTagUsers(search, pageSize, currentPage, status) {
    return this.apiCallService.get(
      APIENDPOINT.collabUserList(search, pageSize, currentPage),
      status
    );
  }

  getWlsTagUsers(search, pageSize, currentPage, type: string = 'tag') {
    return this.apiCallService.post(
      APIENDPOINT.wlsTagUserList(pageSize, currentPage),
      {search, type},
      false
    );
  }

  resetUserPostCount(isEdit?) {
    if (!isEdit) {
      let items;
      this.store
        .select(fromUserProfile.getUserProfileState)
        .pipe(takeUntil(this.destroy$))
        .subscribe((res) => {
          items = Object.assign({ ...res.userProfile });
          items.post_count++;
        });
      this.store.dispatch(new userProfileAction.SetUserProfile(items));
    }
    this.router.navigate(['', this.loggedInUser.user_name]);
  }

  userFollowerList() {
    return this.store.select(fromUserProfile.getFollowerListItems);
  }

  userProfileSubscription() {
    return this.store.select(fromUserProfile.getUserProfileItems);
  }

  loginUserProfile() {
    this.store.select(fromUserProfile.getUserProfileItems)
    .pipe(takeUntil(this.destroy$))
    .subscribe((res) => {
      this.loggedInUser = res;
    });
  }

  userProfile() {
    const origin = environment.websiteURL;
    this.apiCallService
      .get(`${API_URLS.users}?host_name=${origin}`, true)
      .subscribe((res) => {
        if (res.status) {
          if (res.is_suspended) {
            this.authService.removeDetails();
            this.router.navigate(['auth/login']);
            return;
          }
          const mergeObj = {
            ...res.data,
            is_white_label: res.is_white_label,
            is_host_owner: res.is_host_owner
          };
          this.store.dispatch(new userProfileAction.SetUserProfile(mergeObj));
        } else {
          this.cs.showErrorMessage(res.message);
        }
      });
  }

  async openPostPriceModal(userList: CollabPermission[] = [], prefillData?) {
    const { PostPriceComponent } = await import('../components/new-post/dialog-box/post-price/post-price.component');
    const list = [];
    userList?.forEach((ele) => {
      if (Object.keys(ele).length) {
        list.push({
          fullName: `${ele.first_name} ${ele.last_name}`,
          firstName: ele.first_name,
          lastName: ele.last_name,
          userName: ele.user_name,
          email: ele.email,
          profile_pic: ele.profile_pic,
          pk: ele.pk,
          sk: ele.sk
        });
      }
    });
    const modalRef = this.modal.open(PostPriceComponent, {
      modalDialogClass: 'modal-lg post-price-payment-modal',
      backdrop: 'static'
    });
    modalRef.componentInstance.taggedUserList = list;
    modalRef.componentInstance.filledData = Object.keys(prefillData)?.length
      ? prefillData
      : null;
    modalRef.result
      .then((res) => {
        if (!res) {
          return;
        }
        const loyaltyShape = mapSubscriptionDataToLoyaltyLockShape(res);
        if (hasOnlyLoyaltyPointsLock(loyaltyShape)) {
          this.openLoyaltyOnlyWarningAfterPostPrice(res, userList);
          return;
        }
        this.lastAcknowledgedLoyaltyOnlyFingerprint = null;
        this.cs.postSubscriptionData.next(res);
      })
      .catch(() => {});
  }

  shouldSkipLoyaltyOnlyWarningOnSave(subscriptionData: any): boolean {
    if (this.lastAcknowledgedLoyaltyOnlyFingerprint == null) {
      return false;
    }
    return (
      this.lastAcknowledgedLoyaltyOnlyFingerprint ===
      loyaltyOnlyLockAcknowledgementFingerprint(subscriptionData)
    );
  }

  acknowledgeLoyaltyOnlyLockForSubscriptionData(data: any): void {
    this.lastAcknowledgedLoyaltyOnlyFingerprint =
      loyaltyOnlyLockAcknowledgementFingerprint(data);
  }

  private async openLoyaltyOnlyWarningAfterPostPrice(
    res: Record<string, unknown>,
    sourceUserList: CollabPermission[]
  ): Promise<void> {
    const { LoyaltyOnlyWarningModalComponent } = await import('@components/loyalty-only-warning-modal/loyalty-only-warning-modal.component');
    const loyaltyRef: NgbModalRef = this.modal.open(
      LoyaltyOnlyWarningModalComponent,
      {
        modalDialogClass: 'modal-dialog-centered loyalty-only-warning-ngb-modal',
        backdrop: 'static',
        keyboard: false
      }
    );
    const inst = loyaltyRef.componentInstance as InstanceType<typeof LoyaltyOnlyWarningModalComponent>;
    inst.proceeded.pipe(take(1)).subscribe(() => {
      loyaltyRef.close();
      this.lastAcknowledgedLoyaltyOnlyFingerprint =
        loyaltyOnlyLockAcknowledgementFingerprint(res);
      this.cs.postSubscriptionData.next(res);
    });
    inst.canceled.pipe(take(1)).subscribe(() => {
      loyaltyRef.close();
      this.openPostPriceModal(sourceUserList, res);
    });
    setTimeout(() => inst.openModal(), 0);
  }

  onSearch(searchInput: UntypedFormControl) {
    this.atTaggingUsers.next([]);
    return searchInput.valueChanges
      .pipe(
        debounceTime(MENTION_SEARCH.TIMING.INPUT_SETTLE_MS),
        filter(() => this.valueSelected$.value),
        map((text) => this.extractMentionQuery(text)),
        filter((query) => query !== null),
        distinctUntilChanged(),
        switchMap((query) => this.searchMentionUsers(query))
      )
      .subscribe((items) => {
        this.atTaggingUsers.next(items);
        this.adjustMentionsModalTop();
      });
  }

  /**
   * Emits cached matches synchronously when they are available and the
   * debounced server result afterwards. Callers must pipe this through
   * switchMap so a superseded request is cancelled instead of overwriting
   * the list with a late response.
   */
  searchMentionUsers(query: string): Observable<any[]> {
    const normalizedQuery = this.normalizeMentionQuery(query);
    const cachedItems = this.readMentionCache(normalizedQuery);
    if (cachedItems) {
      return of(cachedItems);
    }
    const request$ = timer(MENTION_SEARCH.TIMING.REQUEST_DEBOUNCE_MS).pipe(
      switchMap(() =>
         this.getWlsTagUsers(
          normalizedQuery,
          MENTION_SEARCH.LIMITS.PAGE_SIZE,
          MENTION_SEARCH.LIMITS.PAGE
        )
      ),
      map((res) => this.toMentionUsers(this.getWlsMentionUsers(res))),
      tap((items) => this.writeMentionCache(normalizedQuery, items)),
      catchError(() => EMPTY)
    );
    const previewItems = this.deriveMentionPreview(normalizedQuery);
    return previewItems ? request$.pipe(startWith(previewItems)) : request$;
  }

  private extractMentionQuery(text: unknown): string | null {
    const value = typeof text === 'string' ? text : MENTION_SEARCH.TOKENS.EMPTY;
    const triggerIndex = value.lastIndexOf(MENTION_SEARCH.TRIGGERS.USER);
    const isHashtagActive =
      value.lastIndexOf(MENTION_SEARCH.TRIGGERS.HASHTAG) > triggerIndex;
    if (triggerIndex < Application.ZERO || isHashtagActive) {
      return null;
    }
    const [activeLine] = value
      .slice(triggerIndex + Application.ONE)
      .split(MENTION_SEARCH.TOKENS.LINE_BREAK);
    return activeLine
      .split(MENTION_SEARCH.TOKENS.SPACE)
      .slice(Application.ZERO, MENTION_SEARCH.LIMITS.QUERY_WORDS)
      .join(MENTION_SEARCH.TOKENS.SPACE);
  }

  private normalizeMentionQuery(query: string): string {
    return (query ?? MENTION_SEARCH.TOKENS.EMPTY)
      .replace(/\s+/g, MENTION_SEARCH.TOKENS.SPACE)
      .trim()
      .toLowerCase();
  }

  private getWlsMentionUsers(res): any[] {
    if (Array.isArray(res)) {
      return res;
    }
    return Array.isArray(res?.data) ? res.data : [];
  }

  private mapWlsMentionUser(user) {
    const userId =
      user?.[MENTION_SEARCH.KEYS.WLS_USER_ID] ||
      user?.[MENTION_SEARCH.KEYS.USER_ID];
    return {
      ...user,
      [MENTION_SEARCH.KEYS.WLS_USER_ID]: userId,
      [MENTION_SEARCH.KEYS.USER_ID]: userId,
      pk: user?.pk || userId,
      sk: user?.sk || userId,
      first_name: user?.first_name,
      last_name: user?.last_name,
      user_name: user?.[MENTION_SEARCH.KEYS.USER_LABEL],
      profile_image_url: user?.profile_image_url || user?.profile_pic || ''
    };
  }

  private toMentionUsers(data: any[]): any[] {
    const items = (data ?? [])
      .map((user) => this.mapWlsMentionUser(user))
      .filter(
        (user) =>
          user?.[MENTION_SEARCH.KEYS.USER_ID] &&
          !this.blockedUsers?.includes(user[MENTION_SEARCH.KEYS.USER_ID]) &&
          user[MENTION_SEARCH.KEYS.USER_ID] !==
            this.loggedInUser?.[MENTION_SEARCH.KEYS.USER_ID]
      );
    return [
      ...new Map(
        items.map((item) => [item[MENTION_SEARCH.KEYS.USER_ID], item])
      ).values()
    ];
  }

  private readMentionCache(query: string): any[] | null {
    const entry = this.mentionUserCache.get(query);
    if (!entry) {
      return null;
    }
    if (entry.expiresAt <= Date.now()) {
      this.mentionUserCache.delete(query);
      return null;
    }
    return entry.items;
  }

  private writeMentionCache(query: string, items: any[]): void {
    this.mentionUserCache.delete(query);
    this.mentionUserCache.set(query, {
      items,
      expiresAt: Date.now() + MENTION_SEARCH.TIMING.CACHE_TTL_MS
    });
    while (this.mentionUserCache.size > MENTION_SEARCH.LIMITS.CACHE_ENTRIES) {
      const oldestQuery = this.mentionUserCache.keys().next().value;
      this.mentionUserCache.delete(oldestQuery);
    }
  }

  /**
   * Narrows the widest cached result that the query extends, so the list
   * stays stable and responsive while the server catches up.
   */
  private deriveMentionPreview(query: string): any[] | null {
    let source: any[] | null = null;
    let matchedLength = -1;
    for (const [cachedQuery, entry] of this.mentionUserCache) {
      const isUsableSource =
        entry.expiresAt > Date.now() &&
        query.startsWith(cachedQuery) &&
        cachedQuery.length > matchedLength;
      if (isUsableSource) {
        source = entry.items;
        matchedLength = cachedQuery.length;
      }
    }
    if (!source) {
      return null;
    }
    const matches = source.filter((user) =>
      this.matchesMentionQuery(user, query)
    );
    return matches.length ? matches : null;
  }

  private matchesMentionQuery(user: any, query: string): boolean {
    const searchable = [
      user?.first_name,
      user?.last_name,
      user?.[MENTION_SEARCH.KEYS.USER_LABEL],
      user?.[MENTION_SEARCH.KEYS.DISPLAY_NAME],
      `${user?.first_name ?? MENTION_SEARCH.TOKENS.EMPTY}${
        MENTION_SEARCH.TOKENS.SPACE
      }${user?.last_name ?? MENTION_SEARCH.TOKENS.EMPTY}`
    ]
      .join(MENTION_SEARCH.TOKENS.SPACE)
      .toLowerCase();
    return searchable.includes(query);
  }

  adjustMentionsModalTop() {
    const modal = this.cardsMessageForm?.nativeElement;
    if (!modal) {
      return;
    }
    const rect = modal.getBoundingClientRect();
    if (this.cs.isBrowser) {
      const windowBottom = window.innerHeight;

      if (
        this.mentionModal && 
        rect.bottom > windowBottom * this.MENTION_MODAL_FLIP_THRESHOLD
      ) {
        this.mentionModal.style.removeProperty('top');
        this.mentionModal.style.bottom = '100%';
        this.mentionUl.style.position = 'relative';
      } else {
        this.mentionModal.style.removeProperty('bottom');
        this.mentionModal.style.position = 'absolute';
        this.mentionModal.style.top = '100%';
      }
    }
  }

  setMentionModals(cardsMessageForm) {
    if (this.cs.isBrowser) {
      this.mentionModal = Array.from(
        document.getElementsByTagName('mention-list')
      )[0] as HTMLElement;
      this.mentionUl = Array.from(
        document.getElementsByClassName('mention-menu')
      )[0] as HTMLElement;
      this.cardsMessageForm = cardsMessageForm;
    }
  }

  onMentionPanelOpen() {
    this.valueSelected$.next(true);
  }

  onMentionPanelClosed() {
    this.valueSelected$.next(false);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
